// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"85bf53dd","453":"3154de31","585":"19d5bec8","693":"de2dd38b","723":"af6a33a7","920":"121fdb9d","966":"3f043a4d","969":"8a85dfc7"}[chunkId] + ".chunk.js";
};